<template>
    <activation-brief-networks-provider v-slot="{ handleCompleteConnection }" style="height: 100%">
        <activation-brief-connect-network-failed-view
            @go-to-source="goToSource"
        />
    </activation-brief-networks-provider>
</template>

<script>
    import ActivationBriefConnectNetworkFailedView
        from '../data-views/activation-briefs/partials/networks/ActivationBriefConnectNetworkFailedView';
    import ActivationBriefNetworksProvider from '../providers/activation-brief-steps/ActivationBriefNetworksProvider';
    export default {
        name:       'ConnectNetworkFailedRouterView',
        components: {
            ActivationBriefNetworksProvider,
            ActivationBriefConnectNetworkFailedView,
        },
        methods: {
            goToSource() {
                this.$router.push({ name: 'v2.activation.brief.networks' });
            },
        },
    };
</script>
